import { Controller } from "stimulus";


export default class extends Controller {


  connect() {
    window.dispatchEvent(new CustomEvent("edit-lock-activated"))
    document.querySelectorAll('.kanban-column, #kanban a, #kanban label').forEach(el => {
     el.classList.add("pointer-events-none");
    });
  }

  disconnect() {
    document.querySelectorAll('.kanban-column, #kanban a, #kanban label').forEach(el => {
      el.classList.remove('pointer-events-none');
    })
  }

 
}


